import {CreateInstance} from './config'
const ManagersAPI = CreateInstance('managers')
export default ManagersAPI
